import { ModuleNode } from "../types";

export const AlertModule: ModuleNode = {
    key: "kpi-alerts",
    title: "Data KPI and Alerts",
    submodules: [
        {
            key: "kpi-store",
            title: "KPI Store",
            route: "/dashboard/alertKpiLanding",
            pages: [
                {
                    key: "kpi",
                    title: "KPIs",
                    route: "/kpiFramework/configs",
                    items: [
                        { key: "kpi-config",  label: "All KPI Configs",  tags: ["kpi","config","add kpi config"] },
                    ],
                },
            ],
        },
        {
            key: "alert-framework",
            title: "Alert Framework",
            route: "/dashboard/alertKpiLanding",
            pages: [
                {
                    key: "alerts",
                    title: "Alerts",
                    route: "/alertFramework/alert",
                    items: [
                        { key: "alert",  label: "All Alerts",  tags: ["create","config","alerts"] },
                    ],
                },
            ],
        },
    ],
};
